// AUTO-GENERATED by generate-rxdb-schemas.ts — DO NOT EDIT
// Copyright 2026 Epic Digital Interactive Media LLC
// SPDX-License-Identifier: Apache-2.0

import { defaultHooks } from '../defaults'

const name = 'processexecutions'

/**
 * ProcessExecutions Model Interface (auto-generated from Drizzle schema)
 */
export interface ProcessExecutionsModel {
  id: string
  orgId: string
  workspaceId: string
  userId?: string
  createdAt: string
  updatedAt: string
  metadata?: Record<string, unknown>
  extended?: Record<string, unknown>
  processId: string
  processVersion?: string
  status: string
  progress: number
  currentStepId?: string
  startedAt?: string
  completedAt?: string
  durationMs?: number
  retryCount: number
  maxRetries: number
  inputs: Record<string, unknown>
  outputs?: Record<string, unknown>
  variables: Record<string, unknown>
  context: Record<string, unknown>
  stepHistory: unknown[]
  error?: Record<string, unknown>
  correlationId?: string
  externalId?: string
  parentExecutionId: string
  depth?: number
  resumeAt?: string
  workerId: string
  processName?: string
  archived: boolean
  tenantId?: string
}

export const schema = {
  title: name,
  version: 0,
  primaryKey: 'id',
  type: 'object',
  properties: {
      "id": {
          "type": "string",
          "maxLength": 100
      },
      "orgId": {
          "type": "string",
          "maxLength": 100
      },
      "workspaceId": {
          "type": "string",
          "maxLength": 100
      },
      "userId": {
          "type": "string",
          "maxLength": 100
      },
      "createdAt": {
          "type": "string",
          "maxLength": 200,
          "format": "date-time"
      },
      "updatedAt": {
          "type": "string",
          "maxLength": 200,
          "format": "date-time"
      },
      "metadata": {
          "type": "object"
      },
      "extended": {
          "type": "object"
      },
      "processId": {
          "type": "string",
          "maxLength": 100
      },
      "processVersion": {
          "type": "string",
          "maxLength": 200
      },
      "status": {
          "type": "string",
          "maxLength": 50
      },
      "progress": {
          "type": "integer",
          "minimum": 0,
          "maximum": 100,
          "multipleOf": 1
      },
      "currentStepId": {
          "type": "string",
          "maxLength": 100
      },
      "startedAt": {
          "type": "string",
          "maxLength": 200,
          "format": "date-time"
      },
      "completedAt": {
          "type": "string",
          "maxLength": 200,
          "format": "date-time"
      },
      "durationMs": {
          "type": "integer",
          "minimum": 0,
          "maximum": 2147483647,
          "multipleOf": 1
      },
      "retryCount": {
          "type": "integer",
          "minimum": 0,
          "maximum": 100,
          "multipleOf": 1
      },
      "maxRetries": {
          "type": "integer",
          "minimum": 0,
          "maximum": 100,
          "multipleOf": 1
      },
      "inputs": {
          "type": "object"
      },
      "outputs": {
          "type": "object"
      },
      "variables": {
          "type": "object"
      },
      "context": {
          "type": "object"
      },
      "stepHistory": {
          "type": "array",
          "items": {}
      },
      "error": {
          "type": "object"
      },
      "correlationId": {
          "type": "string",
          "maxLength": 100
      },
      "externalId": {
          "type": "string",
          "maxLength": 100
      },
      "parentExecutionId": {
          "type": "string",
          "maxLength": 100
      },
      "depth": {
          "type": "integer",
          "minimum": 0,
          "maximum": 100,
          "multipleOf": 1
      },
      "resumeAt": {
          "type": "string",
          "maxLength": 200,
          "format": "date-time"
      },
      "workerId": {
          "type": "string",
          "maxLength": 100
      },
      "processName": {
          "type": "string",
          "maxLength": 200
      },
      "archived": {
          "type": "boolean"
      },
      "tenantId": {
          "type": "string",
          "maxLength": 100
      }
  },
  required: [
      "id",
      "orgId",
      "createdAt",
      "updatedAt",
      "processId",
      "status",
      "progress",
      "retryCount",
      "maxRetries",
      "inputs",
      "variables",
      "context",
      "stepHistory",
      "archived",
      "workspaceId",
      "parentExecutionId",
      "workerId"
  ],
  indexes: [
      [
          "orgId",
          "workspaceId",
          "status",
          "createdAt"
      ],
      [
          "orgId",
          "status",
          "createdAt"
      ],
      [
          "orgId",
          "processId",
          "createdAt"
      ],
      [
          "orgId",
          "parentExecutionId",
          "createdAt"
      ],
      [
          "orgId",
          "workerId"
      ]
  ],
}

export const migrationStrategies = {}

export const Collection = {
  name,
  schema,
  hooks: {
    ...defaultHooks({ name }),
  },
  migrationStrategies,
}
